/*
 * @Description:
 * @Date: 2021-09-26 15:02:05
 */
import http from '@/utils/http/axios';
import { ParkPageList } from './types';

enum Api {
  parkPageList = '/front-end/business/park/api/v1/pageList' // 园区列表，不会返回停用园区
}

export const parkPageList: ParkPageList = async params =>
  http.request(
    {
      url: Api.parkPageList,
      method: 'POST',
      params
    }
    // {
    //   yapi: 1287
    // }
  );
